import { RouteObject, Navigate } from "react-router-dom";
import { lazy } from "react";

const Home = lazy(() => import("../pages/home/page"));
const Partnership = lazy(() => import("../pages/partnership/page"));
const Simulator = lazy(() => import("../pages/simulator/page"));
const Advertise = lazy(() => import("../pages/advertise/page"));
const Locations = lazy(() => import("../pages/locations/page"));
const Privacy = lazy(() => import("../pages/privacy/page"));
const Terms = lazy(() => import("../pages/terms/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

// English version pages
const HomeEN = lazy(() => import("../pages/en/home/page"));
const PartnershipEN = lazy(() => import("../pages/en/partnership/page"));
const SimulatorEN = lazy(() => import("../pages/en/simulator/page"));
const AdvertiseEN = lazy(() => import("../pages/en/advertise/page"));
const LocationsEN = lazy(() => import("../pages/en/locations/page"));
const PrivacyEN = lazy(() => import("../pages/en/privacy/page"));
const TermsEN = lazy(() => import("../pages/en/terms/page"));

// Blog pages - English
const BlogLasVegasVisitorStatistics2025EN = lazy(() => import("../pages/en/blog/las-vegas-visitor-statistics-2025/page"));
const BlogLasVegasOOHAdvertisingTrends2025 = lazy(() => import("../pages/en/blog/las-vegas-ooh-advertising-trends-2025/page"));
const BlogBillboardInvestmentTaxBenefitsGuide = lazy(() => import("../pages/en/blog/billboard-investment-tax-benefits-guide/page"));

// Blog pages - Japanese
const BlogLasVegasVisitorStatistics2025JP = lazy(() => import("../pages/blog/las-vegas-visitor-statistics-2025/page"));
const BlogLasVegasOOHAdvertisingTrends2025JA = lazy(() => import("../pages/ja/blog/las-vegas-ooh-advertising-trends-2025/page"));
const JaBlogBillboardInvestmentTaxBenefits = lazy(() => import('../pages/ja/blog/billboard-investment-tax-benefits-guide/page'));

const routes: RouteObject[] = [
  // Default: redirect root to English
  {
    path: "/",
    element: <Navigate to="/en" replace />,
  },

  // English pages (primary)
  {
    path: "/en",
    element: <HomeEN />,
  },
  {
    path: "/en/partnership",
    element: <PartnershipEN />,
  },
  {
    path: "/en/simulator",
    element: <SimulatorEN />,
  },
  {
    path: "/en/advertise",
    element: <AdvertiseEN />,
  },
  {
    path: "/en/locations",
    element: <LocationsEN />,
  },
  {
    path: "/en/privacy",
    element: <PrivacyEN />,
  },
  {
    path: "/en/terms",
    element: <TermsEN />,
  },
  // English blog articles
  {
    path: "/en/blog/las-vegas-visitor-statistics-2025",
    element: <BlogLasVegasVisitorStatistics2025EN />,
  },
  {
    path: "/en/blog/las-vegas-ooh-advertising-trends-2025",
    element: <BlogLasVegasOOHAdvertisingTrends2025 />,
  },
  {
    path: "/en/blog/billboard-investment-tax-benefits-guide",
    element: <BlogBillboardInvestmentTaxBenefitsGuide />,
  },

  // Japanese pages (under /ja)
  {
    path: "/ja",
    element: <Home />,
  },
  {
    path: "/ja/partnership",
    element: <Partnership />,
  },
  {
    path: "/ja/simulator",
    element: <Simulator />,
  },
  {
    path: "/ja/advertise",
    element: <Advertise />,
  },
  {
    path: "/ja/locations",
    element: <Locations />,
  },
  {
    path: "/ja/privacy",
    element: <Privacy />,
  },
  {
    path: "/ja/terms",
    element: <Terms />,
  },
  // Japanese blog articles
  {
    path: "/ja/blog/las-vegas-visitor-statistics-2025",
    element: <BlogLasVegasVisitorStatistics2025JP />,
  },
  {
    path: "/ja/blog/las-vegas-ooh-advertising-trends-2025",
    element: <BlogLasVegasOOHAdvertisingTrends2025JA />,
  },
  {
    path: "/ja/blog/billboard-investment-tax-benefits-guide",
    element: <JaBlogBillboardInvestmentTaxBenefits />,
  },

  // Legacy /ja-less Japanese routes → redirect to /ja equivalents
  {
    path: "/partnership",
    element: <Navigate to="/ja/partnership" replace />,
  },
  {
    path: "/simulator",
    element: <Navigate to="/ja/simulator" replace />,
  },
  {
    path: "/advertise",
    element: <Navigate to="/ja/advertise" replace />,
  },
  {
    path: "/locations",
    element: <Navigate to="/ja/locations" replace />,
  },
  {
    path: "/privacy",
    element: <Navigate to="/ja/privacy" replace />,
  },
  {
    path: "/terms",
    element: <Navigate to="/ja/terms" replace />,
  },

  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;